export enum P2PProviderType {
  Affinex = 'affinex',
  Aggregato = 'aggregato',
  Alaris = 'alaris',
  Almaty = 'almaty',
  Alpina = 'alpina',
  Airpay = 'airpay',
  Ampay = 'ampay',
  Argos = 'argos',
  Arhitec = 'arhitec',
  Astrum = 'astrum',
  BayPay = 'baypay',
  BBBPay = 'bbbpay',
  BBRPay = 'bbrpay',
  BeePay = 'beepay',
  Beikra = 'beikra',
  BillionPay = 'billionpay',
  BitWire = 'bitwire',
  Blackberry = 'blackberry',
  BlackStar = 'blackstar',
  BNPay = 'bnpay',
  Bova = 'bova',
  BucksBunny = 'bucks-bunny',
  BovaMini = 'bova_mini',
  Bridgepay = 'bridgepay',
  Brusnikapay = 'brusnikapay',
  Cactus = 'cactus',
  Coince = 'coince',
  Decard = 'decard',
  Duna = 'duna',
  Easy2Tap = 'easy2tap',
  EasyTokenPay = 'easytokenpay',
  Edro = 'edro',
  EHotPay = 'ehotpay',
  EpayBrl = 'epay-brl',
  EpayV2 = 'epay-v2',
  Europays = 'europays',
  Expay = 'expay',
  ExpayOne = 'expayone',
  Exwave = 'exwave',
  FastPay = 'fastpay',
  Fenix = 'fenix',
  Finex = 'finex',
  FlowPay = 'flowpay',
  Fintrix = 'fintrix',
  Garex = 'garex',
  Flackopay = 'flackopay',
  Forta = 'forta',
  FreeFlow = 'freeflow',
  GiPay = 'gipay',
  Gopago = 'gopago',
  Gotham = 'gotham',
  Havalepayhera = 'havalepayhera',
  Hawaii = 'hawaii',
  HiTrust = 'hitrust',
  IDMPay = 'idm_pay',
  Incas = 'incas',
  InfinityPay = 'infinity-pay',
  IronPay = 'ironpay',
  InternalLike = 'internal_like',
  Jakarta = 'jakarta',
  Jele = 'jele',
  JustMoney = 'just_money',
  Kazex = 'kazex',
  Kingsman = 'kingsman',
  Kvell = 'kvell',
  LazyTrade = 'lazytrade',
  LionTech = 'liontech',
  LuxCore = 'lux-core',
  MacPay = 'macpay',
  ManualResolve = 'manual_resolve',
  ManyPay = 'manypay',
  Mapsign = 'mapsign',
  Mercurio = 'mercurio',
  Meridian = 'meridian',
  Mesa = 'mesa',
  MoneyMania = 'money-mania',
  MoneyHub = 'moneyhub',
  Montra = 'montra',
  Namba = 'namba',
  NambaOne = 'namba_one',
  NambaHyperion = 'namba_hyperion',
  Npay = 'npay',
  Nodex = 'nodex',
  Noros = 'noros',
  NoName = 'no_name',
  OnlyOnePays = 'only_one_pays',
  P2PTrade = 'p2ptrade',
  Panda = 'panda',
  Paylord = 'paylord',
  Pay2Play = 'pay2play',
  Piqpay = 'piqpay',
  Psp24 = 'psp24',
  PayCrown = 'paycrown',
  Paycraft = 'paycraft',
  PaycraftElqr = 'paycraft-elqr',
  PaycraftV1_1 = 'paycraft-v1-1',
  Payfinity = 'payfinity',
  PayMatrix = 'paymatrix',
  PaymentLegacy = 'payment-legacy',
  PayGateCore = 'paygatecore',
  PayPlace = 'payplace',
  Payscrow = 'payscrow',
  PayfinityV2 = 'payfinity_v2',
  PayscrowMobile = 'payscrow-mobile',
  Payshark = 'payshark',
  PayUp = 'payup',
  PayVia = 'payvia',
  Pentax = 'pentax',
  PrMoney = 'prmoney',
  ProFiat = 'profiat',
  Profitable = 'profitable',
  ProfitableLight = 'profitable-light',
  Pulsar = 'pulsar',
  PumP2P = 'pump2p',
  RapidPays = 'rapidpays',
  Reactivepay = 'reactivepay',
  ReactPay = 'reactpay',
  Realpay = 'realpay',
  RiskPay = 'riskpay',
  Rounin = 'rounin',
  RoyalFinance = 'royal_finance',
  Samarsky = 'samarsky',
  SBPay = 'sbpay',
  ScroogePay = 'scroogepay',
  Sequoia = 'sequoia',
  SevenXPay = '7xpay',
  SkyPhoenix = 'sky_phoenix',
  Stbl = 'stbl',
  SwipePay = 'swipepay',
  SwipePayV1 = 'swipepay-v1',
  Titanpay = 'titanpay',
  TitanpayAlfa = 'titanpay-alfa',
  TokenRanch = 'token-ranch',
  Tokyo = 'tokyo',
  Transavex = 'transavex',
  TradeSide = 'tradeside',
  Trust2Pay = 'trust2pay',
  TrustCloud = 'trustcloud',
  TrustPay = 'trustpay',
  Upay = 'upay',
  TeleStore = 'telestore',
  Tenet = 'tenet',
  TestProvider = 'test-provider',
  Unite = 'unite',
  Vexora = 'vexora',
  Vienna = 'vienna',
  Vnd = 'vnd',
  WorldPay = 'worldpay',
  X10Processing = 'x10processing',
  X2X = 'x2x',
  XPayments = 'xpayments',
  YummyPay = 'yummypay',
  Zentra = 'zentra',
}
